import React, { useContext } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import './App.css';
import LoginPage from "./components/LoginPage/LoginPage";
import RecordingPage from "./components/RecordingPage/RecordingPage";
import AdminDashboard from "./pages/AdminPage";
import NavBar from "./components/NavBar";
import { AuthProvider, AuthContext } from "./context/AuthContext";

function AppRoutes() {
  const { isAuthenticated, authLoading } = useContext(AuthContext);
  const location = useLocation();

  if (authLoading) return <div>Loading...</div>;

  const hideNav = location.pathname === "/login";

  return (
    <>
      {!hideNav && <NavBar />}
      <Routes>
        <Route
          path="/login"
          element={
            isAuthenticated ? <Navigate to="/" replace /> : <LoginPage />
          }
        />
        <Route
          path="/"
          element={
            isAuthenticated ? <RecordingPage /> : <Navigate to="/login" replace />
          }
        />
        <Route
          path="/admin"
          element={
            isAuthenticated ? <AdminDashboard /> : <Navigate to="/login" replace />
          }
        />
      </Routes>
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppRoutes />
      </Router>
    </AuthProvider>
  );
}

export default App;
